import { AppDataSync } from '@conexasaude/analytics'
import { useMemo } from 'react'
import { IS_PRODUCTION } from '@/constants'
import { User } from '@/modules/Auth/classes/User'
import { useLocation } from 'react-router-dom'

export const useAnalyticsData = (user?: User) => {
  const { pathname } = useLocation()

  const analyticsDataSync: AppDataSync = useMemo(
    () => ({
      pathname,
      devEnvironment: !IS_PRODUCTION,
      user: {
        analyticsUserId: user?.cpf,
        id: user?.id,
        patientId: user?.patientId,
        clinic: {
          id: user?.clinic?.id,
          name: user?.clinic?.name,
        },
      },
      gtag: {
        default: true,
      },
      gtm: {
        default: true,
      },
      clarity: {
        default: true,
        enabled: IS_PRODUCTION,
      },
      maze: {
        default: true,
      },
    }),
    [user, pathname],
  )

  return analyticsDataSync
}
